import React, { useState, useContext, createContext, useMemo } from 'react'
import PropTypes from 'prop-types'
import ExpandableHeader from './ExpandableHeader'
import LoadingDots from '../LoadingDots'

const SectionContext = createContext({
  isLocked: false,
  showContent: true,
  onExpandClick: () => {}
})

export function ExpandedContent (props) {
  const { showContent } = useContext(SectionContext)

  if (showContent) return props.children
  return null
}

ExpandedContent.propTypes = {
  children: PropTypes.node
}

export function SectionHeader (props) {
  const { isLocked, onExpandClick, showContent } = useContext(SectionContext)

  return (
    <ExpandableHeader
      locked={isLocked}
      handleClick={onExpandClick}
      expanded={showContent}
      title={props.children}
      {...props}
    />
  )
}

SectionHeader.propTypes = {
  callout: ExpandableHeader.propTypes.callout,
  children: PropTypes.node,
  rightCallout: ExpandableHeader.propTypes.rightCallout
}

export function ViewMoreButton ({ show, onViewMore }) {
  if (!show) { return null }

  const [isLoading, setIsLoading] = useState(false)

  const handleViewMoreClick = async (e) => {
    setIsLoading(true)
    await onViewMore(e)
    setIsLoading(false)
  }

  return (
    <>
      <div className='section-bottom padding-2 text-center'>

        <LoadingDots show={isLoading} />

        <button
          onClick={handleViewMoreClick}
          className='color-pro-steel-grey-600 font-bold pointer-clickable display-inline-block'
        >
          View More
        </button>
      </div>
    </>
  )
}

ViewMoreButton.propTypes = {
  show: PropTypes.bool,
  onViewMore: PropTypes.func
}

ViewMoreButton.defaultProps = {
  show: false
}

const Section = (props) => {
  const [expanded, setExpanded] = useState(props.expanded)
  const isLocked = props.locked

  const contextValue = useMemo(() => {
    let showContent = true

    if (props.expandable) {
      showContent = expanded
    }

    const toggleExpanded = () => {
      setExpanded(prev => !prev)
    }

    return {
      showContent,
      isLocked,
      onExpandClick: toggleExpanded
    }
  }, [expanded, props.expandable, isLocked])

  const classNameList = () => {
    let list = [
      'section',
      'pro-rounded',
      'pro-closest-shadow'
    ]

    if (props.padded) {
      list = [...list, 'pro-padded']
    }

    return list.join(' ')
  }

  return (
    <SectionContext.Provider value={contextValue}>
      <div className={classNameList()} id={props.idText} data-magellan-target={props.idText} data-testid={props.idText}>
        {props.children}
      </div>
    </SectionContext.Provider>
  )
}

Section.propTypes = {
  children: PropTypes.node,
  expandable: PropTypes.bool,
  expanded: PropTypes.bool,
  idText: PropTypes.string,
  locked: PropTypes.bool,
  padded: PropTypes.bool
}

Section.defaultProps = {
  expanded: false
}

export default Section
